/* Seneglow: shared "add to cart, then Fastrr cart checkout" helper.
   Used by the Glow Atelier builder (sections/sg-byo-builder.liquid).
   Fastrr code is only called here (window.shiprocketCheckoutEvents.buyCart), never changed. */
(() => {
  if (window.SGCartCheckout) return;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const openCheckout = (event) => {
    const sr = window.shiprocketCheckoutEvents;
    if (sr && typeof sr.buyCart === 'function') sr.buyCart(event || null);
    else window.location.href = root + 'cart';
  };

  window.SGCartCheckout = {
    // items: [{ id, quantity }]. Adds them to the existing cart (never clears it), then opens checkout.
    async go(items, event) {
      const list = items.filter((i) => i && i.id && i.quantity > 0).map((i) => ({ id: i.id, quantity: i.quantity }));
      if (!list.length) throw new Error('Your box is empty.');

      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: list })
      });
      if (!res.ok) {
        let msg = '';
        try { msg = (await res.json()).description || ''; } catch (e) { /* not JSON */ }
        throw new Error(msg || 'Could not add to cart. Please try again.');
      }
      openCheckout(event);
    }
  };
})();
